import React, { useState } from 'react';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import { Divider, IconButton, Typography } from '@mui/material';
import { CloseIcon, tableEditWhiteIcon } from '../../../assets/images';
import LeadViewDetailsModal from '../LeadViewDetailsModal/LeadViewDetailsModal';
import { LoginResponseType } from '../../../redux/auth/authTypes';
import DrawerLoader from '../../commons/DrawerLoader/DrawerLoader';
import ClientMeetUpDetailsModal from './ClientMeetUpDetailsModal';

type Anchor = 'top' | 'left' | 'bottom' | 'right';


interface CustomDrawerProps {
  isRight: boolean;
  isOpen: boolean;
  onClose: () => void;
  history:any;
  clientCode:number| null;
  singleClientMeetUpCheckListData:any
 loginData: LoginResponseType;
 fetching:boolean;



}

const AllClientMeetUpRightDrawer: React.FC<CustomDrawerProps> = ({ 
  isRight, 
  isOpen, 
  onClose,
   history  , 
  clientCode , 
  singleClientMeetUpCheckListData,
  loginData,
  fetching

}) => {
    const LocalDrawerContent = (
      <Box
        sx={{
          width: 800,
          padding: 2,
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto', 
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
          <div style={{display:'flex' , alignItems:'center' , gap:'17px'}}>
          <IconButton onClick={onClose}> 
            <img src={CloseIcon} alt="Close Icon" />
          </IconButton>
          
          <Typography variant="h6" sx={{fontSize:'18px' , fontWeight:'500'}}>Client Meet Up Details</Typography>
          </div>


 
        </Box>
          <hr style={{ margin: '2px 0px'  }} />
        {fetching && <DrawerLoader/>}
       <ClientMeetUpDetailsModal singleClientMeetUpCheckListData={singleClientMeetUpCheckListData} loginData={loginData} />
        <div>
      </div>
      </Box>
    );
    return (
      <div>
        {isRight && (
          <React.Fragment>
            <Drawer
              anchor="right"
              open={isOpen} 
              onClose={onClose} 
            >

              {LocalDrawerContent}
            </Drawer>
            
          </React.Fragment>
        )}
      </div>
    );
  };
  
  export default AllClientMeetUpRightDrawer;
  

